import dataCities from '../cities.json';

const cityRankingData = Object.entries(dataCities).map(([, city]) => {
    return {
        City: city.city,
        Country: city.country,
        Region: city.region,
        Slug: city.slug,
        Income_Group: city.income_group,
        Population: city.population,
        GDP_Per_Capita: city.gdp_per_capita,
        
        /**
         * Overall Future Readiness
         */
        future_readiness: {
            score: city.future_readiness_score,
            rank: city.future_readiness_rank,
        },
        
        /**
         * 8 Main Pillars
         */
        people_centricity: {
            score: city.people_centricity_score,
            rank: city.people_centricity_rank,
        },
        openness: {
            score: city.openness_score,
            rank: city.openness_rank,
        },
        sustainability: {
            score: city.sustainability_score,
            rank: city.sustainability_rank,
        },
        institutions_governance: {
            score: city.institutions_governance_score,
            rank: city.institutions_governance_rank,
        },
        transport_infrastructure: {
            score: city.transport_infrastructure_score,
            rank: city.transport_infrastructure_rank,
        },
        innovation: {
            score: city.innovation_score,
            rank: city.innovation_rank,
        },
        vibrancy: {
            score: city.vibrancy_score,
            rank: city.vibrancy_rank,
        },
        e_intelligence: {
            score: city.e_intelligence_score,
            rank: city.e_intelligence_rank,
        },
        
        /**
         * 16 Sub-Pillars
         */
        liveability: {
            score: city.liveability_score,
            rank: city.liveability_rank,
        },
        access_to_services: {
            score: city.access_to_services_score,
            rank: city.access_to_services_rank,
        },
        investment_openness: {
            score: city.investment_openness_score,
            rank: city.investment_openness_rank,
        },
        talent_competitiveness: {
            score: city.talent_competitiveness_score,
            rank: city.talent_competitiveness_rank,
        },
        urban_design: {
            score: city.urban_design_score,
            rank: city.urban_design_rank,
        },
        energy_waste: {
            score: city.energy_waste_score,
            rank: city.energy_waste_rank,
        },
        institutions: {
            score: city.institutions_score,
            rank: city.institutions_rank,
        },
        governance: {
            score: city.governance_score,
            rank: city.governance_rank,
        },
        mobility: {
            score: city.mobility_score,
            rank: city.mobility_rank,
        },
        digital_infrastructure: {
            score: city.digital_infrastructure_score,
            rank: city.digital_infrastructure_rank,
        },
        rd_intensity: {
            score: city.rd_intensity_score,
            rank: city.rd_intensity_rank,
        },
        ip_intensity: {
            score: city.ip_intensity_score,
            rank: city.ip_intensity_rank,
        },
        financial_activity: {
            score: city.financial_activity_score,
            rank: city.financial_activity_rank,
        },
        cultural_vibrancy: {
            score: city.cultural_vibrancy_score,
            rank: city.cultural_vibrancy_rank,
        },
        data_readiness: {
            score: city.data_readiness_score,
            rank: city.data_readiness_rank,
        },
        ai_readiness: {
            score: city.ai_readiness_score,
            rank: city.ai_readiness_rank,
        }
    }
})

export default cityRankingData
